/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_TimeframeInputs */

const en__field_timeframe = /** @type {(inputs: _Field_TimeframeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semester`)
};

const de__field_timeframe = /** @type {(inputs: _Field_TimeframeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semester`)
};

/**
* | output |
* | --- |
* | "Semester" |
*
* @param {_Field_TimeframeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_timeframe = /** @type {((inputs?: _Field_TimeframeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_TimeframeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_timeframe(inputs)
	return de__field_timeframe(inputs)
});